function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.32 21.46h4.384a4 4 0 004-4v-5.703h-3v5.704a1 1 0 01-1 1h-4.383v3zm0-18.433h4.384a1 1 0 011 1v4.73h3v-4.73a4 4 0 00-4-4h-4.383v3zm-3-3v3H4.27a1 1 0 00-1 1v4.73h-3v-4.73a4 4 0 014-4h6.05zm0 18.433v3H4.27a4 4 0 01-4-4v-5.703h3v5.704a1 1 0 001 1h6.05z",
  fill: "#FDD113"
})));